import { tlISODateTimeToLocalNoSecondsString, NotificationSendService, BaseTLDetailComponent, AxiosResponse, RightHelper, Watch, EventRoleFilter,EventRoleService, RoleService, RoleFilter } from "../../../Infrastructure/CorBase/CoreBase";

interface iFormDataEventRole {
	id: number;
	roleName: string;
	roleDescription: string;
	idEvent: number;
	idTenant: number;
	idRole: number;
	viaPortal: boolean;
	viaEmail: boolean;
	isNew: boolean;
	isChange: boolean;
	isDelete: boolean;
};

interface iFormDataEvent {
	id: number;
	value: number;
	text: string;
	name: string;
	description: string;
	templateIdentifier: string;
	templateSubject: string;
	templateBody: string;
	isDefaultEmail: boolean;
	isDefaultPortal: boolean;
};
interface iFormDataContentHead {
	id: number;
	name: string;
	description: string;	
	contents: iFormDataEventRole[];
};

interface iRole {
	id: number;
	name: string;
	identifier: string;
	description: string;
};

export default abstract class NotificationSettingDetailBase extends BaseTLDetailComponent {


	returnRoute: string = "NotificationSendList";
	notificationSendService: NotificationSendService = new NotificationSendService();
	roleService: RoleService = new RoleService();

	selectedEventId = -1;
	selectedEvent: iFormDataEvent = {
		id: 0,
		description: "",
		isDefaultEmail: false,
		isDefaultPortal:false,
		name: "",
		templateIdentifier: "",
		templateSubject: "",
		templateBody: "",
		text: "",
		value: 0
	}
	eventRoleService: EventRoleService = new EventRoleService();

	returnStudentId = '';
	eventList: iFormDataEvent[] = [];
	eventRoleList: iFormDataEventRole[] = [];
	eventRoleListOld: iFormDataEventRole[] = [];
	roleList: iRole[] = [];
	roleListModal: iRole[] = [];

	eventRoleDataSave: iFormDataEventRole[] = [];

	createBase() {
		this.eventList = [];
		this.eventRoleService.getAllEvent().then(response => {
			
			for (var i = 0; i < response.data.length; i++) {
				if (this.eventList.some(c => c.id == response.data[i].id) == false) {
					this.eventList.push({
						value: response.data[i].id,
						text: response.data[i].name,
						description: response.data[i].description,
						name: response.data[i].name,
						id: response.data[i].id,
						templateIdentifier: response.data[i].templateIdentifier,
						templateSubject: response.data[i].templateSubject,
						templateBody: response.data[i].templateBody,
						isDefaultPortal: response.data[i].isDefaultPortal,
						isDefaultEmail: response.data[i].isDefaultEmail
					});

				}

				this.eventList.sort((a, b) => a.name.localeCompare(b.name));
				if (this.eventList.length > 0) {
					this.selectedEventId = this.eventList[0].id;
					this.selectedEvent = this.eventList[0];
					this.formHeadData[0].name = this.eventList[0].name;
					this.formHeadData[0].id = this.selectedEvent.id;
				}
			}

		});


		this.roleList = [];

		var filter = new EventRoleFilter(null, this.$store.state.idTenant);
		this.eventRoleService.getAllByFilter(filter).then(response => {
		
			this.eventRoleList = response.data;
			this.eventRoleData = this.eventRoleList.filter(c => c.idEvent == this.selectedEvent.id);
			this.eventRoleDataOld = [];
			this.eventRoleData.forEach(val => this.eventRoleDataOld.push(Object.assign({}, val)));
			this.eventRoleList.forEach(val => this.eventRoleListOld.push(Object.assign({}, val)));
		});

		let roleFilter: RoleFilter = new RoleFilter(null, null, this.$store.state.idTenant);
		this.roleService.getAllByFilter(roleFilter).then(res => {
			this.roleList = res.data;
		});


	}

	@Watch('selectedEventId')
	onEventSelectChange(newVal: number, old: number) {
		if (newVal != old) {
			this.selectedEvent = this.eventList.filter(c => c.id == newVal)[0];
			this.eventRoleData = this.eventRoleList.filter(c => c.idEvent == newVal);
			this.eventRoleDataOld = [];
			this.eventRoleData.forEach(val => this.eventRoleDataOld.push(Object.assign({}, val)));
			this.formHeadData[0].name = this.selectedEvent.name;
			this.formHeadData[0].id = this.selectedEvent.id;
		}
	}

	goBackNotChangeAllBase() {
		this.eventRoleData = [];
		this.eventRoleList = [];
		this.eventRoleDataOld.forEach(val => this.eventRoleData.push(Object.assign({}, val)));
		this.eventRoleListOld.forEach(val => this.eventRoleList.push(Object.assign({}, val)));
	}


	///hlaska o prekroceni inputu po Ctrl+V
	protected infoShortInputBase(maxLength: string): void {
		this.showAlertModalWithTitleAndContent(this.$t('global.messageInfo').toString(), this.$t('global.messageShortInput').toString() + maxLength + this.$t('global.messageShortInput2').toString());
	}

	formData = {
		id: 0 as number,
		subject: '' as string,
		body: '' as string,
		idPersonNavigation: '' as string,
		sendStatus: '' as string,
		sendDate: '' as string,
		sendAddress: '' as string,
		person: null
	}

	protected fetchDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall();
		//return this.notificationSendService.getById(this.objectId);
	}

	protected fetchRefreshDataFromServer(): Promise<AxiosResponse<any>> {
		return super.NoCall()
	}

	protected refreshItems(items: any, refreshData: any): any {
		return items;
	}

	protected processResponse(response: AxiosResponse<any>): void {

	}

	protected afterCreate(response: AxiosResponse<any>): void {
		this.formData.id = response.data.id;
	}

	doAction() {
		super.doCRUDActionWithInfoMessage(this.$t('notificationSetting.messageNew').toString(), this.$t('notificationSetting.messageEdit').toString(), this.$t('notificationSetting.messageDelete').toString());
	}

	protected updateObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.update(this.objectId, this.formData);
	}

	protected createObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.create(this.formData);
	}

	protected deleteObject(): Promise<AxiosResponse<any>> {
		return this.notificationSendService.delete(this.objectId);
	}

	//test tabulka

	//formDataContentHead: iFormDataContentHead[] = [];
	formDataContentHeadOld: iFormDataContentHead[] = [];
	formDataContentHeadSettingOld: iFormDataContentHead[] = [];



	fieldsEventRole = [	
		//{ key: 'id', label: 'id', trans: 'taskDetail.fieldName', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
		//{ key: 'idRole', label: 'idRole', trans: 'taskDetail.fieldName', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
		//{ key: 'idEvent', label: 'idEvent', trans: 'notificationSetting.fieldEvent', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
		{ key: 'roleName', label: this.$t('notificationSetting.fieldRole'), trans: 'notificationSetting.fieldRole', sortable: false, class: 'text-left ', thClass: 'firstColumnMichael' },
		{ key: 'roleDescription', label: this.$t('notificationSetting.fieldRoleDesc'), trans: 'notificationSetting.fieldRoleDesc', sortable: false, class: 'text-center  '},
		{ key: 'viaPortal', label: this.$t('notificationSetting.fieldViaWeb'), trans: 'notificationSetting.fieldViaWeb', sortable: false, class: 'text-center helpWidth30 ', design: 'checkBox' },
		{ key: 'viaEmail', label: this.$t('notificationSetting.fieldViaMail'), trans: 'notificationSetting.fieldViaMail', sortable: false, class: 'text-center helpWidth30 ', design: 'checkBox' },
		{ key: 'actions', label: this.$t('notificationSetting.fieldAction'), trans: 'notificationSetting.fieldAction', sortable: false, class: 'text-right' },
	];

	fieldsRoleModal = [
	//	{ key: 'id', label: 'id', trans: 'role.fieldName', sortable: true, class: 'text-left', thClass: 'firstColumnMichael' },
		{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', sortable: true, class: 'text-left', thClass: 'firstColumnMichael' },
		{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', sortable: true, class: 'text-left' },
	];

		filtersRoleModal = [
			//{ key: 'identifier', label: this.$t('role.filterIdentif'), trans: 'role.filterIdentif', selected: false, value: null, type: 'text' },
			{ key: 'name', label: this.$t('role.fieldName'), trans: 'role.fieldName', selected: false, value: null, type: 'text', lang: this.$store.state.currentLanguage },
			{ key: 'description', label: this.$t('role.fieldDescription'), trans: 'role.fieldDescription', selected: false, value: null, type: 'text' }
		];



	eventRoleData: iFormDataEventRole[] = [{
		id: 1,
		roleName: 'jmeno',
		roleDescription: 'descdddt',
		idEvent: 0,
		idRole: 0,
		idTenant:0,
		viaEmail: true,
		viaPortal: true,
		isNew: false,
		isChange: false,
		isDelete: false,
	}];

	eventRoleDataOld: iFormDataEventRole[] = [];

	formHeadData: iFormDataContentHead[] = [
		{
			id: 1,
			description: '',
			name: '',
			contents: []
		}
	]

	
	changeCheckboxBase(item: any, item2: any, item3: any, item4: any) {
		var eventRole = this.eventRoleData.filter(c => c.id == item)[0];
		if (item3 == 'viaPortal') {
			eventRole.viaPortal = !eventRole.viaPortal;
			if (!eventRole.viaPortal && !eventRole.viaEmail) {
				eventRole.viaEmail = true;
			}
		}
		if (item3 == 'viaEmail') {
			eventRole.viaEmail = !eventRole.viaEmail;
			if (!eventRole.viaPortal && !eventRole.viaEmail) {
				eventRole.viaPortal = true;
			}
		}
	}

	addContentDetailBase(idEvent: any) {
		var notSelectedRole = this.roleList.filter(c => !this.eventRoleData.some(d => d.idRole == c.id));	
		
		this.roleListModal = [];
		notSelectedRole.forEach(val => this.roleListModal.push(Object.assign({}, val)));
		this.$bvModal.show('eventRoleModal');
	}

	deleteContentDetailBase(item: any) {
		this.eventRoleData = this.eventRoleData.filter(c => c.id != item);
		this.eventRoleList = this.eventRoleList.filter(c => c.id != item);
	}

	deleteAllBase(item: number) {
		this.eventRoleData = this.eventRoleData.filter(c => c.idEvent != item);
		this.eventRoleList = this.eventRoleList.filter(c => c.idEvent != item);
	}

	addRoleEventBase(items: Array<number>) {

		let maxId = this.eventRoleList.length+1;
		for (var i = 0; i < items.length; i++) {
			maxId++;
			let roleO = this.roleListModal.filter(c => c.id == items[i])[0];
			let role = this.roleList.filter(c => c.id == items[i])[0];

			let addItem: iFormDataEventRole;
			var existOld = this.eventRoleListOld.find(c => c.id == role.id);
			if (existOld == undefined) {
				addItem = {
					id: maxId,
					idEvent: this.selectedEvent.id,
					idRole: role.id,
					roleName: role.name,
					roleDescription: role.description,
					idTenant: this.$store.state.idTenant,
					viaEmail: false,
					viaPortal: true,
					isNew: true,
					isChange: false,
					isDelete: false
				};
			}
			else {
				existOld.viaPortal = true;
				addItem = existOld;
			}
			this.eventRoleList.push(addItem);
			this.eventRoleData.push(addItem);
        }  
	}

	//krok zpet ale pouze pro idEvent
	goBackContentDetailBase(item: any) {
		this.eventRoleList = this.eventRoleList.filter(c => c.idEvent != this.selectedEvent.id);
		this.eventRoleListOld.filter(c => c.idEvent == this.selectedEvent.id).forEach(val => this.eventRoleList.push(Object.assign({}, val)));
		this.eventRoleData = this.eventRoleList.filter(c => c.idEvent == this.selectedEvent.id);
	}

	showGoBackButton() {
		let listNew = this.eventRoleList.filter(c => c.idEvent == this.selectedEvent.id);
		let listOld = this.eventRoleListOld.filter(c => c.idEvent == this.selectedEvent.id);

		let result = listNew.length === listOld.length &&
			listNew.every(c => listOld.some(d => d.id === c.id && d.viaEmail == c.viaEmail && d.viaPortal == c.viaPortal));

		return !result;
	}


	showSaveAllButton() {
		let result = this.eventRoleList.length === this.eventRoleListOld.length &&
			this.eventRoleList.every(c => this.eventRoleListOld.some(d => d.id === c.id && d.viaEmail == c.viaEmail && d.viaPortal == c.viaPortal));
		return result;
	}

	showDeleteBlockButton() {
		return this.eventRoleData.length > 0;
	}

	prepareSaveOneEvent() {
		this.eventRoleDataSave = [];
		this.eventRoleData.forEach(item => {
			//kontrola zmen
			var beforeItem = this.eventRoleListOld.find(c => c.id == item.id);
			if (beforeItem != null) {
				if (beforeItem.viaEmail !== item.viaEmail || beforeItem.viaPortal !== item.viaPortal) {
					item.isChange = true;
					this.eventRoleDataSave.push(item);
				}
			}
		});

		//pridani nových
		this.eventRoleDataSave.push(...this.eventRoleData.filter(c => c.isNew === true));

		//zjisteni smazaných
		// Vytvoření setu ID pro rychlejší vyhledávání
		const currentIds = new Set(this.eventRoleData.map(item => item.id));

		this.eventRoleDataOld.forEach(item => {
			// Kontrola, zda ID neexistuje v aktuálním setu
			if (!currentIds.has(item.id)) {
				item.isDelete = true;
				this.eventRoleDataSave.push(item);
			}
		})
	}

	prepareSaveAllEvent() {
		this.eventRoleDataSave = [];
		this.eventRoleList.forEach(item => {
			//kontrola zmen
			var beforeItem = this.eventRoleListOld.find(c => c.id == item.id);
			if (beforeItem != null) {
				if (beforeItem.viaEmail !== item.viaEmail || beforeItem.viaPortal !== item.viaPortal) {
					item.isChange = true;
					this.eventRoleDataSave.push(item);
				}
			}
		});

		//pridani nových
		this.eventRoleDataSave.push(...this.eventRoleList.filter(c => c.isNew === true));

		//zjisteni smazaných
		// Vytvoření setu ID pro rychlejší vyhledávání
		const currentIds = new Set(this.eventRoleList.map(item => item.id));

		this.eventRoleListOld.forEach(item => {
			// Kontrola, zda ID neexistuje v aktuálním setu
			if (!currentIds.has(item.id)) {
				item.isDelete = true;
				this.eventRoleDataSave.push(item);
			}
		});

	}

	//ulozeni jednoho eventu
	saveOneEvent() {
		this.prepareSaveOneEvent();
		this.eventRoleService.updateEventRoleOneEvent(this.$store.state.idTenant, this.selectedEventId, this.eventRoleDataSave).then(res => {
			
			this.eventRoleList = this.eventRoleList.filter(c => c.idEvent != this.selectedEventId);
			this.eventRoleList.push(...res.data);

			this.eventRoleListOld = this.eventRoleListOld.filter(c => c.idEvent != this.selectedEventId);
			res.data.forEach((val:any) => this.eventRoleListOld.push(Object.assign({}, val)));

			this.eventRoleData = this.eventRoleList.filter(c => c.idEvent == this.selectedEvent.id);
			this.eventRoleDataOld = [];
			this.eventRoleData.forEach(val => this.eventRoleDataOld.push(Object.assign({}, val)));
			
		});
	}

	saveAll() {
		this.prepareSaveAllEvent();
		this.eventRoleService.updateEventRole(this.$store.state.idTenant, this.eventRoleDataSave).then(res => {			
			this.eventRoleList = res.data;
			this.eventRoleData = this.eventRoleList.filter(c => c.idEvent == this.selectedEvent.id);
			this.eventRoleDataOld = [];
			this.eventRoleData.forEach(val => this.eventRoleDataOld.push(Object.assign({}, val)));
			this.eventRoleListOld = [];
			this.eventRoleList.forEach(val => this.eventRoleListOld.push(Object.assign({}, val)));
		});
	}

}
